<div
    role="alertdialog"
    aria-described-by="timer-loader-content"
    id="timer-loader-overlay"
    class="d-flex align-items-center justify-content-center"
    *ngIf="showLoader"
>
    <div id="timer-loader">
        <div id="timer-loader-content" class="e-content-wrap">
            <span class="fas fa-hourglass-half"></span>
            {{ loaderMessage }}
        </div>
    </div>
</div>
